import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Contact from "./components/Contact";
import WishlistSidebar from "./components/WishlistSidebar";
import QuickViewModal from "./components/QuickViewModal";
import { AppProvider } from "./context/AppContext";
import EnquiryModal from './components/EnquiryModal';
import "./styles.css";

function App() {
  return (
    <AppProvider>
      <Router>
        <div className="app">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <WishlistSidebar />
          <QuickViewModal />
          <EnquiryModal />
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
